export * as generalConstants from "./generalConstants.js";
export * as i18nConstants from "./i18nConstants.js";
